import moment from 'moment';
import React from 'react';
import {TIME_FORMAT_USER} from '../../../data/constants/datetime';
import {useI18n} from '../../../data/hooks/i18nHooks';
import {eventMomentFactory} from '../../../data/misc/eventMomentFactory';

// NOTE: logic copied from netwerkapp/Models/MeetingSlotsResult.cs #49

const TimeInterval = props => {
    const {event, session, slot, format} = props,
        intervalObject = session || slot,
        eventTimeStart = eventMomentFactory(event, intervalObject.start_local),
        eventTimeEnd = eventMomentFactory(event, intervalObject.end_local),
        localTimeStart = moment(intervalObject.start_local, format).local(),
        localTimeEnd = moment(intervalObject.end_local, format).local(),
        i18n = useI18n();

    if (event.show_in_user_timezone) {
        return (
            <>
                {localTimeStart.format(TIME_FORMAT_USER)} - {localTimeEnd.format(TIME_FORMAT_USER)}
            </>
        );
    } else if (eventTimeStart.utcOffset() != localTimeStart.utcOffset()) {
        return (
            <>
                {eventTimeStart.format(TIME_FORMAT_USER)} - {eventTimeEnd.format(TIME_FORMAT_USER)}
                <br />
                {i18n['label.in-yout-timezone']}: {localTimeStart.format(TIME_FORMAT_USER)} - {localTimeEnd.format(TIME_FORMAT_USER)}
            </>
        );
    }
    return (
        <>
            {eventTimeStart.format(TIME_FORMAT_USER)} - {eventTimeEnd.format(TIME_FORMAT_USER)}
        </>
    );
};

export default TimeInterval;
